import { usersApi } from "api/User/api.ts";

import GetMeRequest = App.Http.Requests.User.GetMeRequest;

export function composeGetMeQueryOptions(request: GetMeRequest) {
    return {
        queryKey: ["me", request],
        queryFn: () => usersApi.getMe(request),
        staleTime: 0,
        gcTime: 0,
    };
}

export function getMeQueryOptions(request: GetMeRequest) {
    return {
        ...composeGetMeQueryOptions(request),
        suspense: true,
    };
}
